import React from 'react';

import Tooltip from 'antd/lib/tooltip';

import Admin from 'hive-admin';
import Query from 'hive-admin/src/components/Query';
// eslint-disable-next-line max-len
import FieldWYSIWYGToolbarItemInline from 'hive-admin/src/components/FieldWYSIWYGToolbarItemInline';

// eslint-disable-next-line max-len
export default class FieldWYSIWYGPostLinkToolbarItem extends FieldWYSIWYGToolbarItemInline {
  static config = {
    ...FieldWYSIWYGToolbarItemInline.config,
    TYPE: 'ALPHA_POST_LINK',
    toolbarTitle: 'Post Link',
    modalTitle: 'Post Link',
    decorators: [
      ['FieldWYSIWYGDecorator', {
        mapPropsFromWYSIWYG: ({ client, base }) => ({ client, base }),
        renderItem: (data, children, props) => (
          <Query
            client={props.client}
            extractData={response => (response ? response.data : null)}
            url={`posts/${data.target}`}
          >
            {queryProps => (
              queryProps.data
              ? (
                  <Tooltip
                    title={(
                      <a
                        style={{ color: '#fff' }}
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`${
                          props.base
                        }/${
                          queryProps.data.type.toLowerCase().replace(/s?$/, 's')
                        }/${
                          data.target
                        }`}
                      >
                        {`Open "${queryProps.data.title}"`}
                      </a>
                    )}
                  >
                    <a>{children}</a>
                  </Tooltip>
                )
              : (
                  <Tooltip title="Post does not exist!">
                    <a><strike>{children}</strike></a>
                  </Tooltip>
                )
            )}
          </Query>
        ),
      }],
    ],
    fields: [
      ['FieldText', {
        name: 'text',
        rules: [['validation.isRequired']],
        placeholder: 'Title',
      }],
      ['FieldConnectionSelect', {
        name: 'target',
        label: 'Post',
        placeholder: 'Select the post to link to',
        url: '/posts',
        rules: [['validation.isRequired']],
        labelKey: 'title',
        searchPaths: ['title'],
      }],
    ],
    actions: [
      ['Action', {
        name: 'Close',
        type: 'default',
        onClick: props => props.onClose(),
      }],
      ['Action', {
        name: 'Remove',
        type: 'default',
        onClick: props => props.onRemove(),
      }],
      ['Action', {
        name: 'Add',
        disabled: [['condition.anyFieldHasError']],
        onClick: (props) => {
          props.form.validateFields((errors, values) => {
            if (!errors) {
              props.onAdd(values);
              props.onClose();
            }
          });
        },
      }],
    ],
  }
}

Admin.addToLibrary(
  'FieldWYSIWYGPostLinkToolbarItem',
  config => FieldWYSIWYGPostLinkToolbarItem.create(config),
);
